import { ReactNode } from 'react';

import classNames from 'classnames';

export interface WrapperProps {
  children: ReactNode;
  size?: 'normal' | 'medium' | 'narrow';
  padX?: boolean;
  padY?: boolean;
  className?: string;
}

export function Wrapper({
  children,
  size = 'normal',
  padY = false,
  padX = true,
  className = undefined,
}: WrapperProps) {
  return (
    <div
      className={classNames(
        'mx-auto w-full',
        {
          'max-w-screen-pagewrapper': size === 'normal',
          'max-w-8xl': size === 'medium',
          'max-w-5xl': size === 'narrow',
          'px-5 lg:px-10': padX,
          'py-10 lg:py-20': padY,
        },
        className,
      )}
    >
      {children}
    </div>
  );
}
